var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.333599,0 C0.598284,0 0,0.598284 0,1.3335985 L0,14.6664015 C0,15.4017236 0.598284,16 1.333599,16 L14.666401,16 C15.401723,16 16,15.4017236 16,14.6664015 L16,1.3335985 C16,0.598284 15.401724,0 14.666401,0 L1.333599,0 Z",
    fill: "#ffa300",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.075396,3.1859976 L11.357869,3.1859976 C11.542205,3.1859976 11.69127,3.3353872 11.69127,3.5193972 L11.69127,12.4802097 C11.69127,12.6645448 11.542205,12.8136093 11.357869,12.8136093 L9.075396,12.8136093 C8.891062,12.8136093 8.74239,12.6645448 8.74239,12.4802097 L8.74239,3.5193972 C8.74239,3.3353872 8.891062,3.1859976 9.075396,3.1859976 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.642131,3.1859976 L6.924603,3.1859976 C7.108591,3.1859976 7.258004,3.3353872 7.258004,3.5193972 L7.258004,12.4802097 C7.258004,12.6645448 7.108591,12.8136093 6.924603,12.8136093 L4.642131,12.8136093 C4.457811,12.8136093 4.308731,12.6645448 4.308731,12.4802097 L4.308731,3.5193972 C4.308731,3.3353872 4.457811,3.1859976 4.642131,3.1859976 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaused);
export default __webpack_public_path__ + "static/media/paused.35297483da06771e150adec252bc5162.svg";
export { ForwardRef as ReactComponent };